var render = function render(){var _vm=this,_c=_vm._self._c;return ( _vm.content.txt !== 'reset' )?_c('div',{class:_vm.getClasses(_vm.content),style:(_vm.getStyle(_vm.content))},[_vm._v(_vm._s(_vm.content.txt.trim())),_c('span',{staticClass:"chawget-msg-date"},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }